import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

export default function InboisPelbagai({ onClick, disabled }) {
  return (
    <Button
      variant="contained"
      color="info"
      size="small"
      onClick={onClick}
      disabled={disabled}
      style={{
        background: 'linear-gradient(0deg,rgba(0, 99, 15, 1) 0%,rgba(0, 206, 31, 1) 100%)',
        color: '#fff',
      }}
      sx={{ mr: 1 }}
    >
      Inbois Pelbagai
    </Button>
  );
}

InboisPelbagai.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
